import Vue from 'vue'

const state = {
    checkNotificationsInterval: null,
    isBellNotificationOpen: false,
    bellNotificationList: [],
    isFetchingTopNotifications: false,
    isFetchingAllNotifications: false,
    unviewedNotificationsCount: 0,
    fetchedFirstTime: false, // this is used to knwo if the user has just logged in and we whant to show "You have X unread messages"
    notifications: [],
    floatingNotifications: [],
    unreadNotificationsNr: Number,
    notificationTypes: [
        {
            "id": 0,
            "description": "Generic"
        },
        {
            "id": 1,
            "description": "System"
        },
        {
            "id": 2,
            "description": "Protocol"
        },
        {
            "id": 3,
            "description": "Booking"
        },
        {
            "id": 4,
            "description": "Connect"
        }
    ],
    isfromNotification: false
}

const getters = {
    getCheckNotificationsInterval: state => state.checkNotificationsInterval,
    getIsBellNotificationOpen: state => state.isBellNotificationOpen,
    getBellNotificationList: state => state.bellNotificationList,
    getIsFetchingNotifications: state => state.isFetchingTopNotifications,
    getIsFetchingAllNotifications: state => state.isFetchingAllNotifications,
    getUnviewedNotificationsCount: state => state.unviewedNotificationsCount,
    getNotifications: state => state.notifications,
    getFloatingNotifications: state => state.floatingNotifications,
    getNotificationTypes: state => state.notificationTypes,
    getUnreadNotificationsNr: state => state.unreadNotificationsNr,
    getIsfromNotification: state => state.isfromNotification,
}

const actions = {
    setCheckNotificationsInterval: ({ commit }, payload) => {
        commit('SET_CHECK_NOTIFICATIONS_INTERVAL', payload)
    },

    toggleBellNotificationPopup: ({ commit, dispatch, state }, openState) => {
        if (typeof openState == "undefined") {
            //set current notification list as read
            if (state.isBellNotificationOpen == true) {
                dispatch('markAllNotificationsViewed')
                // dispatch('setNotificationsAsViewed', state.bellNotificationList)
            }

            commit('CHANGE_NOTIFICATION_BELL_POPUP', !state.isBellNotificationOpen)
        } else {

            //set current notification list as read
            if (openState == false) {
                dispatch('markAllNotificationsViewed')
                // dispatch('setNotificationsAsViewed', state.bellNotificationList)
            }

            commit('CHANGE_NOTIFICATION_BELL_POPUP', openState)
        }
    },

    setBellNotificationList: ({ commit }, payload) => {
        commit('SET_BELL_NOTIFICATION_LIST', payload)
    },

    fetchUnviewdNotificationsCount: ({ commit, dispatch, state, rootState }) => {
        commit('SET_ISFETCHINGNOTIFICATIONS', true);

        if (rootState.user.account.supplierId && rootState.user.account.id) {
            return axios.get(axios.defaults.baseURL + 'api/notification/getTotalUnviewed', {}).then(response => {
                if (response.status == 200) {
                    let fetchedTopNotifications = response.data;

                    commit('SET_UNVIWED_NOTIFICATIONS_COUNT', fetchedTopNotifications);

                    if (state.fetchedFirstTime == false && fetchedTopNotifications > 0) {
                        dispatch('addFloatingNotification', {
                            title: 'You have ' + fetchedTopNotifications + ' new notification' + (fetchedTopNotifications > 1 ? 's' : '')
                        });
                    }
                }
                commit('SET_ISFETCHINGNOTIFICATIONS', false);
                commit('CHANGE_FETCHEDFIRSTTIME', true);

                return response;
            }).catch(error => {
                commit('SET_ISFETCHINGNOTIFICATIONS', false);

                return error;
            })
        } else {
            dispatch('handleLogout');
        }
    },

    fetchNotifications: ({ commit, dispatch, state, rootState }, payload) => {
        let pagination = {
            page: payload.pagination.currentPage ? payload.pagination.currentPage : 1,
            pageSize: payload.pagination.pageSize ? payload.pagination.pageSize : 25,
            "search.supplierId": rootState.user.account.supplierId,
            "search.userAccountId": rootState.user.account.id,
            "search.type": payload.search && typeof payload.search.type != 'undefined' ? payload.search.type : null,
            "search.typeStatus": null,
        }

        commit('SET_ISFETCHINGALLNOTIFICATIONS', true)
        //pull notifications from API
        if (rootState.user.account.id) {
            // return axios.get(axios.defaults.baseURL + 'api/notification/list',{
            return axios.get(axios.defaults.baseURL + 'api/notification/getNotifications', {
                params: pagination
            }).then((response) => {
                commit('SET_ISFETCHINGALLNOTIFICATIONS', false)
                if (response && response.status === 200) {


                    commit('SET_NOTIFICATIONS', response.data);
                    return response.data
                }
            })
                .catch(function (error) {
                    commit('SET_ISFETCHINGNOTIFICATIONS', false)
                });
        }
    },

    clearAllNotifications: ({ commit }, payloadNotification) => {
        commit('SET_NOTIFICATIONS', [])
        commit('REMOVE_ALL_FLOAT_NOTIFICATIONS')
        commit('SET_ISFETCHINGNOTIFICATIONS', [])
    },

    markNotificationAsRead: ({ commit, rootState }, payloadNotifications) => {
        let notificationIdList

        if (typeof payloadNotifications == "object") {
            payloadNotifications.markedAsRead = true
            notificationIdList = [payloadNotifications.broadcastId]
        }

        // TODO: else if array

        axios.post(axios.defaults.baseURL + 'api/notification/setAsRead', {
            NotificationIdList: notificationIdList
        }).then((response) => {
            if (response && response.status === 200) {
            }
        })
            .catch(function (error) {
            });

    },

    markNotificationAsUnread: ({ commit, rootState }, payloadNotifications) => {
        let notificationIdList

        if (typeof payloadNotifications == "object") {
            payloadNotifications.markedAsRead = false
            notificationIdList = [payloadNotifications.broadcastId]
        }

        // TODO: else if array


        axios.post(axios.defaults.baseURL + 'api/notification/setAsUnread', {
            NotificationIdList: notificationIdList
        }).then((response) => {
            if (response && response.status === 200) {
            }
        })
            .catch(function (error) {
            });

    },

    deleteNotification: ({ commit, dispatch, rootState }, payloadNotifications) => {
        let notificationIdList

        if (typeof payloadNotifications == "object") {
            payloadNotifications.markedAsRead = true
            commit('REMOVE_NOTIFICATION', payloadNotifications.id)
            notificationIdList = [payloadNotifications.broadcastId]
        }

        axios.post(axios.defaults.baseURL + 'api/notification/setAsDeleted', {
            NotificationIdList: notificationIdList
        }).then((response) => {
            if (response && response.status === 200) {
                commit('REMOVE_NOTIFICATION', payloadNotifications.id)
            }
        })
            .catch(function (error) {
            });

    },

    setNotificationsAsViewed: ({ commit, rootState, dispatch }, notificationsArray) => {
        let idArray
        // if idArray is an array of notifications instad of id's we clean it up
        if (notificationsArray && notificationsArray.length > 0 && typeof notificationsArray[0] == 'object') {
            // create id array
            idArray = notificationsArray.filter(n => { return n.markedAsViewed == false }).map(n2 => { return n2.broadcastId })
            // set notifications as viewed (localy)
            notificationsArray.map(notification => {
                notification.markedAsViewed = true
            })
        }

        if (idArray.length > 0) {

            // subtract from bell red indicator
            dispatch('subtractFromUnviewedNotificationCount', idArray.length)

            return axios.post('/api/notification/setAsViewed', {
                notificationIdList: idArray
            }).then(response => {
                return response
            }).catch(error => {

                return error
            })
        } else {
            return false
        }
    },

    markAllNotificationsRead: ({ commit, rootState }) => {
        state.unviewedNotificationsCount = 0
        axios.post('/api/Notification/setAllAsRead', {
        }).then(response => {
            commit('MARK_ALL_NOTIFICATIONS_READ', rootState);
        })
    },

    markAllNotificationsViewed: ({ commit, rootState }) => {
        axios.post('/api/Notification/setAllAsViewed', {
        }).then(response => {
            commit('SET_UNVIWED_NOTIFICATIONS_COUNT', 0);
        })
    },

    deleteAllnotifications: ({ commit, rootState }) => {
        return axios.post('/api/Notification/setAllAsDeleted', {
        }).then(response => {
            commit('SET_NOTIFICATIONS', []);
            return response
        }).catch(error => {

            return error
        })
    },

    subtractFromUnviewedNotificationCount: ({ commit }, amount) => {
        commit('SET_UNVIWED_NOTIFICATIONS_COUNT', state.unviewedNotificationsCount - amount)
    },

    supplierRejectAgentInvite: ({ state, dispatch }, payload) => {
        return axios.get('api/Community/SupplierRejectAgentRequest', {
            params: {
                supplierId: payload.supplierId,
                protocolId: payload.protocolId,
                notificationId: payload.notificationId
            }
        }).then((response) => {
            if (response && response.status === 200) {
                Vue.toasted.info('Agent request was rejected');
                dispatch('changeNotificationLocally', {
                    notificationId: payload.notificationId,
                    dataToChange: {
                        typeStatus: 401
                    }
                })
                dispatch('fetchNotifications', { pagination: 1 }).then(response => {
                    dispatch('setBellNotificationList', (response.result))
                })
            }
            return response
        })
            .catch(function (error) {

                return error
            });
    },

    showNewNotificationCard: ({ state }, notification) => {
        // Vue.toasted.error('showNewNotificationCard');
        Vue.$awm.info("Your custom message")
    },

    changeNotificationLocally: ({ state, rootState }, payload) => {
        // *************************************
        // payload.notificationId = id of the notification to change
        // payload.dataToChange = {title:'newTite', typeStatus: 401} how many you whant to change
        // *************************************

        // debugger
        let notificationToChange = state.notifications.result.find(notification => {
            return notification.id == payload.notificationId
        })

        if (notificationToChange) {
            Object.keys(payload.dataToChange).forEach((key) => {
                Vue.set(notificationToChange, key, payload.dataToChange[key]);
            });
        }

    },

    // floating notifications

    addFloatingNotification: ({ state, commit }, notification) => {
        commit('PUSH_FLOAT_NOTIFICATION', notification)
    },

    removeFloatingNotification: ({ state, commit }, notification) => {
        commit('REMOVE_FLOAT_NOTIFICATION', notification)
    },

    removeAllFloatingNotifications: ({ state, commit }, notification) => {
        commit('REMOVE_ALL_FLOAT_NOTIFICATIONS', notification)
    },

    setIsFromNotification: ({ state, commit }, notification) => {
        commit('SET_IS_FROM_NOTIFICATION', notification);
    },
}

const mutations = {
    SET_CHECK_NOTIFICATIONS_INTERVAL: (state, payload) => {
        state.checkNotificationsInterval = payload
    },
    CLEAR_CHECK_NOTIFICATIONS_INTERVAL: (state, payload) => {
        clearInterval(state.checkNotificationsInterval)
    },
    CHANGE_NOTIFICATION_BELL_POPUP: (state, payload) => {
        state.isBellNotificationOpen = payload
    },
    SET_BELL_NOTIFICATION_LIST: (state, payload) => {
        state.bellNotificationList = payload
    },
    SET_ISFETCHINGNOTIFICATIONS: (state, payload) => {
        state.isFetchingTopNotifications = payload
    },

    SET_ISFETCHINGALLNOTIFICATIONS: (state, payload) => {
        state.isFetchingAllNotifications = payload
    },

    SET_UNVIWED_NOTIFICATIONS_COUNT: (state, count) => {
        state.unviewedNotificationsCount = count > 0 ? count : 0;
    },

    SET_NOTIFICATIONS: (state, notifications) => {
        state.notifications = notifications;
    },

    SET_NOTIFICATION_TYPES: (state, data) => {
        state.notificationTypes = data;
    },

    MARK_ALL_NOTIFICATIONS_READ: (state, rootState) => {
        state.unviewedNotificationsCount = []
    },

    REMOVE_NOTIFICATION: (state, notificationId) => {
        let findNewNotification = state.notifications.result.filter(notification => {
            return notification.id == notificationId
        })[0]

        state.notifications.result.splice(state.notifications.result.indexOf(findNewNotification), 1)

    },

    PUSH_FLOAT_NOTIFICATION: (state, notification) => {
        state.floatingNotifications.push(notification)
    },

    REMOVE_FLOAT_NOTIFICATION: (state, notification) => {
        state.floatingNotifications.splice(state.floatingNotifications.indexOf(notification), 1)
    },

    REMOVE_ALL_FLOAT_NOTIFICATIONS: (state, notification) => {
        state.floatingNotifications = []
    },

    CHANGE_FETCHEDFIRSTTIME: (state, status) => {
        state.fetchedFirstTime = status
    },

    SET_IS_FROM_NOTIFICATION: (state, status) => {
        state.isfromNotification = status
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}


// helpers
function findNewNotification(array1, array2) {
    const temp = [];
    array1 = array1.toString().split(',').map(Number);
    array2 = array2.toString().split(',').map(Number);

    for (var i in array1) {
        if (!array2.includes(array1[i])) {
            temp.push(array1[i])
        }
    }

    for (i in array2) {
        if (!array1.includes(array2[i])) {
            temp.push(array2[i])
        }
    }

    return temp.sort((a, b) => a - b);
}

function findNewNotification2(a1, a2, prop) {
    return a1.filter(o1 => a2.filter(o2 => o2[prop] === o1[prop]).length === 0);
}



// WEBPACK FOOTER //
// ./src/store/modules/notifications.js